import { Logger } from "~/utils";

export const errorHandler = (error: Error): void => {
  Logger.error(error);
};
